import React from 'react';

const AboutUs: React.FC = () => {
  return (
    <section className="py-24 px-4 bg-gradient-to-b from-dance-cream to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-dance-navy mb-6 tracking-wide">
            ABOUT US
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-dance-gold to-dance-terracotta mx-auto"></div>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-6">
            <p className="text-xl text-dance-navy leading-relaxed font-light">
              The Dance Floor isn't a studio — <b>it's Austin's home for dancers.</b>
            </p>
            <p className="text-lg text-dance-navy/80 leading-relaxed">
              Join to connect with people who share your passion, get exclusive invites to members-only mixers and community socials, and be the first to hear about dance events happening across the city.
            </p>
            <p className="text-lg text-dance-navy/80 leading-relaxed">
              <i>As a founding member, you'll help shape how this space grows and become part of the heartbeat of Austin's dance community.</i>
            </p>
          </div>
          
          <div className="flex justify-center">
            <img 
              src="/images/tdflogofull.svg"
              alt="Dancing at The Dance Floor"
              className="w-full h-full rounded-xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
